
































import Vue from "vue";

//Component
import SecurityConfigurationCard from "./SecurityConfigurationCard.vue";
import StocksConfigurationDetail from "@/views/App/SecurityAndConfiguration/StocksConfiguration/StocksConfigurationDetail.vue";

//Model
import { Configuration } from "@/model/data/security/Configuration";
import { RollProfile } from "@/model/data/security/InstallationStocksConfiguration";
import { TemplateContentEnum } from "@/model/data/enums/TemplateContentEnum";

export default Vue.extend({
    components: { SecurityConfigurationCard, StocksConfigurationDetail },
    props: {
        configuration: { type: Object as () => Configuration, required: true },
        showDialog: { type: Boolean, required: true },
        fromStocksConfig: { type: Boolean, default: false },
        rollsProfile: RollProfile,
        templateContent: { type: Number as () => TemplateContentEnum, required: false },
        templateName: { type: String, required: false },
    },
    computed: {
        showActualConfiguration: {
            get() {
                return this.showDialog;
            },
            set(newValue: boolean) {
                this.$emit("update:showDialog");
            },
        },
    },
});
